import { useState } from "react";
import HomeUsdt from "../../../components/chart/home-usdt";
import "./quotations.scss";

const Quotations = () => {

    const[total, setTotal] = useState<number | null>(null);

    const calcualteFee = (event:any) => {
        console.dir(event.target.value);
        const sendTotal = parseFloat(event.target.value) * 0.9999 * 5.53;
        if (sendTotal && sendTotal > 0) setTotal(sendTotal);
    } 

    const fixedRate = (rate: number) => {
        const sendTotal = parseFloat((1 * rate).toString()) * 0.9999 * 5.53;
        return sendTotal.toFixed(4);
    }

    return (
        <div className="quotations-wrapper">

            <h1 className="page-title">
                Cotacoes
                <small>Calcule a cotacao do dolar a ser vendido para o cliente.</small>
            </h1>

            <div className="quotations-items">
                <div className="left">
                    <div className="header">
                        <span>#</span>
                        <span>Nome</span>
                        <span>Value</span>
                    </div>
                    <ul>
                        <li>
                            <span>1</span>
                            <span>Dolar Comercial</span>
                            <span className="currency">R$ 5,53</span>
                        </li>
                        <li>
                            <span>2</span>
                            <span>USDT - USD</span>
                            <span className="currency">0.9999</span>
                        </li>
                    </ul>

                    <div className="trade">
                        <h3>Calculo de Cotacao</h3>

                        <div className="trade-fields">
                            <div className="field">
                                <label>Taxa</label>
                                <input type="text" className="tax" placeholder="Taxa de conversao Ex: 1.008" onChange={ (event) => calcualteFee(event) }/>
                            </div>
                            <div className="field">
                                <label>Total</label>
                                <input type="text" className="total" placeholder="Total em U$D" disabled value={total?.toFixed(4) ?? ""}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="right">
                    <HomeUsdt />
                </div>
            </div>

            <div>
                <h3>Exemplos:</h3>

                <div className="examples">

                    <div className="example">
                        <div className="trade-fields">
                            <div className="field">
                                <label>Taxa</label>
                                <input type="text" className="tax" placeholder="Taxa de conversao Ex: 1.008" disabled value={1.008} />
                            </div>
                            <div className="field">
                                <label>Total</label>
                                <input type="text" className="total" placeholder="Total em U$D" disabled value={fixedRate(1.008)}/>
                            </div>
                        </div>
                    </div>
                    <div className="example">
                        <div className="trade-fields">
                            <div className="field">
                                <label>Taxa</label>
                                <input type="text" className="tax" placeholder="Taxa de conversao Ex: 1.008" disabled value={1.007} />
                            </div>
                            <div className="field">
                                <label>Total</label>
                                <input type="text" className="total" placeholder="Total em U$D" disabled value={fixedRate(1.007)}/>
                            </div>
                        </div>
                    </div>
                    <div className="example">
                        <div className="trade-fields">
                            <div className="field">
                                <label>Taxa</label>
                                <input type="text" className="tax" placeholder="Taxa de conversao Ex: 1.008" disabled value={1.0077} />
                            </div>
                            <div className="field">
                                <label>Total</label>
                                <input type="text" className="total" placeholder="Total em U$D" disabled value={fixedRate(1.0077)}/>
                            </div>
                        </div>
                    </div>
                    <div className="example">
                        <div className="trade-fields">
                            <div className="field">
                                <label>Taxa</label>
                                <input type="text" className="tax" placeholder="Taxa de conversao Ex: 1.008" disabled value={1.006} />
                            </div>
                            <div className="field">
                                <label>Total</label>
                                <input type="text" className="total" placeholder="Total em U$D" disabled value={fixedRate(1.006)}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            
        </div>
    )

}

export default Quotations;